export const LOAD_MULTI_ACCOUNTS = 'LOAD_MULTI_ACCOUNTS';
export const MULTI_ACCOUNTS_LOADED = 'MULTI_ACCOUNTS_LOADED';
export const SYNC_FAILED = 'SYNC_FAILED';
export const RESET_ERROR = 'RESET_ERROR';
